module.exports = __webpack_public_path__ + "img/a2.93af85be.jpg";